// import { PhotoCamera } from "@mui/icons-material";
import { useNavigate } from 'react-router-dom';
import { H3 } from 'components/Typography';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import {
    Box,
    Button,
    Card,
    Grid,
    IconButton,
    styled,
    Switch,
    FormHelperText,
} from '@mui/material';
import AppTextField from 'components/input-fields/AppTextField';
// import { Small, Tiny } from "components/Typography";
import { useFormik } from 'formik';
import DashboardLayout from 'layouts/Dashboard/DashboardLayout';
import EventAdminCreateService from 'services/event/EventAdminCreateService';
import * as Yup from 'yup'; // styled components

const ButtonWrapper = styled(Box)(({ theme }) => ({
    width: 100,
    height: 100,
    display: 'flex',
    borderRadius: '50%',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: theme.palette.action.disabledBackground,
}));
const UploadButton = styled(Box)(({ theme }) => ({
    width: 50,
    height: 50,
    display: 'flex',
    borderRadius: '50%',
    border: '2px solid',
    alignItems: 'center',
    justifyContent: 'center',
    borderColor: theme.palette.background.paper,
    backgroundColor: theme.palette.action.disabledBackground,
}));
const SwitchWrapper = styled(Box)(() => ({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
    marginTop: 10,
}));

const EventAdminCreate = () => {
    const navigate = useNavigate();
    const initialValues = {
        // fullName: "",
        // email: "",
        // phone: "",
        // country: "",
        // state: "",
        // city: "",
        // address: "",
        end: '',
        start: '',
        name: '',
        description: '',
    };
    const validationSchema = Yup.object().shape({
        // fullName: Yup.string().required("Name is Required!"),
        // email: Yup.string().email().required("Email is Required!"),
        // phone: Yup.number().min(8).required("Phone is Required!"),
        // country: Yup.string().required("Country is Required!"),
        // state: Yup.string().required("State is Required!"),
        // city: Yup.string().required("City is Required!"),
        // address: Yup.string().required("Address is Required!"),
        name: Yup.string().required('Event Name is Required!'),
        start: Yup.date().required('Start Date is Required!'),
        end: Yup.date()
            .required('End Date is Required!')
            .when(
                'start',
                (start, schema) =>
                    start &&
                    schema.min(start, 'End date must be later than start date'),
            ),
        description: Yup.string().required('Description is Required!'),
    });
    const {
        values,
        errors,
        handleChange,
        handleSubmit,
        setFieldValue,
        touched,
    } = useFormik({
        initialValues,
        validationSchema,
        onSubmit: async (values) => {
            await EventAdminCreateService(values);
            navigate('/dashboard/admin/event');
        },
    });
    return (
        <DashboardLayout>
            <Box pt={2} pb={4}>
                <Grid container spacing={3}>
                    {/* <Grid item md={4} xs={12}>
            <Card sx={{
            padding: 3,
            minHeight: 400,
            display: "flex",
            flexDirection: "column",
            alignItems: "center"
          }}>
              <ButtonWrapper>
                <UploadButton>
                  <label htmlFor="upload-btn">
                    <input accept="image/*" id="upload-btn" type="file" style={{
                    display: "none"
                  }} />
                    <IconButton component="span">
                      <PhotoCamera sx={{
                      fontSize: 26,
                      color: "white"
                    }} />
                    </IconButton>
                  </label>
                </UploadButton>
              </ButtonWrapper>

              <Small marginTop={2} maxWidth={200} lineHeight={1.9} display="block" textAlign="center" color="text.secondary">
                Allowed *.jpeg, *.jpg, *.png, *.gif max size of 3.1 MB
              </Small>

              <Box maxWidth={250} marginTop={5} marginBottom={1}>
                <SwitchWrapper>
                  <Small display="block" fontWeight={600}>
                    Public Profile
                  </Small>
                  <Switch defaultChecked />
                </SwitchWrapper>

                <SwitchWrapper>
                  <Small display="block" fontWeight={600}>
                    Banned
                  </Small>
                  <Switch defaultChecked />
                </SwitchWrapper>
                <Tiny display="block" color="text.secondary" fontWeight={500}>
                  Apply disable account
                </Tiny>

                <SwitchWrapper>
                  <Small display="block" fontWeight={600}>
                    Email Verified
                  </Small>
                  <Switch defaultChecked />
                </SwitchWrapper>
                <Tiny display="block" color="text.secondary" fontWeight={500}>
                  Disabling this will automatically send the user a verification
                  email
                </Tiny>
              </Box>
            </Card>
          </Grid> */}
                    <Grid item md={12} xs={12}>
                        <Card
                            sx={{
                                padding: 3,
                            }}
                        >
                            <H3 sx={{ mt: 0 }}>Create New Event</H3>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <form onSubmit={handleSubmit}>
                                    <Grid container spacing={3}>
                                        {/* <Grid item sm={6} xs={12}>
                      <AppTextField fullWidth name="fullName" label="Full Name" value={values.fullName} onChange={handleChange} error={Boolean(touched.fullName && errors.fullName)} helperText={touched.fullName && errors.fullName} />
                    </Grid>

                    <Grid item sm={6} xs={12}>
                      <AppTextField fullWidth name="email" label="Email Address" value={values.email} onChange={handleChange} error={Boolean(touched.email && errors.email)} helperText={touched.email && errors.email} />
                    </Grid>

                    <Grid item sm={6} xs={12}>
                      <AppTextField fullWidth name="phone" label="Phone Number" value={values.phone} onChange={handleChange} error={Boolean(touched.phone && errors.phone)} helperText={touched.phone && errors.phone} />
                    </Grid>

                    <Grid item sm={6} xs={12}>
                      <AppTextField fullWidth name="country" label="Country" value={values.country} onChange={handleChange} error={Boolean(touched.country && errors.country)} helperText={touched.country && errors.country} />
                    </Grid>

                    <Grid item sm={6} xs={12}>
                      <AppTextField fullWidth name="state" label="State/Region" value={values.state} onChange={handleChange} error={Boolean(touched.state && errors.state)} helperText={touched.state && errors.state} />
                    </Grid>

                    <Grid item sm={6} xs={12}>
                      <AppTextField fullWidth name="city" label="City" value={values.city} onChange={handleChange} error={Boolean(touched.city && errors.city)} helperText={touched.city && errors.city} />
                    </Grid>

                    <Grid item sm={6} xs={12}>
                      <AppTextField fullWidth name="address" label="Address" value={values.address} onChange={handleChange} error={Boolean(touched.address && errors.address)} helperText={touched.address && errors.address} />
                    </Grid> */}

                                        <Grid item sm={12} xs={12}>
                                            <AppTextField
                                                fullWidth
                                                name="name"
                                                label="Event Name"
                                                value={values.name}
                                                onChange={handleChange}
                                                error={Boolean(
                                                    touched.name && errors.name,
                                                )}
                                                helperText={
                                                    touched.name && errors.name
                                                }
                                            />
                                        </Grid>
                                        <Grid item sm={6} xs={12}>
                                            <DateTimePicker
                                                sx={{
                                                    width: '100%',
                                                }}
                                                label="Start date"
                                                value={values.start}
                                                onChange={(date) =>
                                                    setFieldValue('start', date)
                                                }
                                                renderInput={(inputProps) => (
                                                    <AppTextField
                                                        fullWidth
                                                        variant="outlined"
                                                        {...inputProps}
                                                    />
                                                )}
                                            />
                                            {Boolean(
                                                touched.start && errors.start,
                                            ) && (
                                                <Box sx={{ ml: 2 }}>
                                                    <FormHelperText error>
                                                        {errors.start}
                                                    </FormHelperText>
                                                </Box>
                                            )}
                                        </Grid>
                                        <Grid item sm={6} xs={12}>
                                            <DateTimePicker
                                                sx={{
                                                    width: '100%',
                                                }}
                                                label="End date"
                                                value={values.start}
                                                onChange={(date) =>
                                                    setFieldValue('end', date)
                                                }
                                                renderInput={(inputProps) => (
                                                    <AppTextField
                                                        fullWidth
                                                        variant="outlined"
                                                        {...inputProps}
                                                    />
                                                )}
                                            />
                                            {Boolean(
                                                touched.end && errors.end,
                                            ) && (
                                                <Box sx={{ ml: 2 }}>
                                                    <FormHelperText error>
                                                        {errors.end}
                                                    </FormHelperText>
                                                </Box>
                                            )}
                                        </Grid>

                                        <Grid item xs={12}>
                                            <AppTextField
                                                multiline
                                                fullWidth
                                                rows={10}
                                                name="description"
                                                label="Event Description"
                                                value={values.description}
                                                onChange={handleChange}
                                                error={Boolean(
                                                    touched.description &&
                                                        errors.description,
                                                )}
                                                helperText={
                                                    touched.description &&
                                                    errors.description
                                                }
                                                sx={{
                                                    '& .MuiOutlinedInput-root textarea':
                                                        {
                                                            padding: 0,
                                                        },
                                                }}
                                            />
                                        </Grid>

                                        <Grid item xs={12}>
                                            <Button
                                                type="submit"
                                                variant="contained"
                                            >
                                                Create Event
                                            </Button>
                                        </Grid>
                                    </Grid>
                                </form>
                            </LocalizationProvider>
                        </Card>
                    </Grid>
                </Grid>
            </Box>
        </DashboardLayout>
    );
};

export default EventAdminCreate;
